import {EventEmitter, Injectable, Output} from '@angular/core';
import { HttpClient } from "@angular/common/http";
import {environment} from "../../environments/environment";
import {map, Observable, tap} from "rxjs";
import {User} from "../_models/user";
import {Router} from "@angular/router";
import {convertSystemRoleToEnum} from "../_util/utils";
import {AccessPolicyService} from "./access-policy.service";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private isLoggingOut = false;

  @Output() currentUser$: EventEmitter<User | null> = new EventEmitter<User | null>();

  constructor(private http: HttpClient,
              private router: Router,
              private accessPolicyService: AccessPolicyService) { }
  login(loginData: any): Observable<any> {
    let formData = new FormData();
    formData.append("email", loginData.email);
    formData.append("password", loginData.password);
    formData.append("remember_me", loginData.remember_me);
    return this.http.post<User>(`${environment.serverUrl}/login`, formData, {withCredentials: true}).pipe(
      tap(() => this.accessPolicyService.clear()),
      map((user) => {
        console.log(user)
        user.systemRole = convertSystemRoleToEnum(user.systemRole);
        this.currentUser$.emit(user);
        this.accessPolicyService.ensureLoaded().subscribe();
        return user;
    }));
  }

  logout(redirectBackAfterLogin = false) {
    const returnUrl = window.location.pathname + window.location.search;

    if (this.isLoggingOut || this.router.url.startsWith('/login')) return;
    this.isLoggingOut = true;

    this.makeLogoutRequest().subscribe(() => {
      this.accessPolicyService.clear();
      this.currentUser$.emit(null);

      if (redirectBackAfterLogin) this.router.navigateByUrl(`/login?returnUrl=${redirectBackAfterLogin ? returnUrl: ''}`);
      else this.router.navigateByUrl(`/login`);

      this.isLoggingOut = false;
    })
  }

  makeLogoutRequest(){
    return this.http.post(`${environment.serverUrl}/logout`, '', {observe: "response", withCredentials: true});
  }
}
